import React, { createContext, useContext, useState } from "react";

const ForumContext = createContext();

export const ForumProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [selectedForum, setSelectedForum] = useState("");
  const [selectedSport, setSelectedSport] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const handleMyForumClick = (profileId) => {
    setUserId(profileId);
    setSelectedForum("myForum");
  };

  const handleAllForumClick = () => {
    setUserId(null);
    setSelectedForum("viewAll");
  };
  const updateSelectedSport = (sport) => {
    setSelectedSport(sport);
  };
  const updateSelectedForum = (Forum) => {
    setSelectedForum(Forum);
  };
  const updateSelectedSchool = (school) => {
    setSelectedSchool(school);
  };

  return (
    <ForumContext.Provider
      value={{
        userId,
        setUserId,
        selectedForum,
        handleMyForumClick,
        handleAllForumClick,
        setSelectedSport,
        setSelectedForum,
        selectedSport,
        updateSelectedSport,
        updateSelectedForum,
        selectedSchool,
        updateSelectedSchool,
      }}
    >
      {children}
    </ForumContext.Provider>
  );
};

export const useForumContext = () => {
  return useContext(ForumContext);
};
